"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("./core");
function Spacer(_a) {
    var _b = _a.space, space = _b === void 0 ? '$none' : _b;
    return react_1.default.createElement(StyledSpacer, { space: space });
}
exports.Spacer = Spacer;
var StyledSpacer = core_1.styled('div', {}, { space: core_1.mapTokens('space', function (value) { return ({ '--space': value }); }) });
